import { SsrCtx } from '@/core/vue.types';

export const resolveFromCtx = <T>(key: string, ctx: SsrCtx): T => {
  return (ctx.app as any)._provided[key];
};
